import { render, staticRenderFns } from "./LawyersList.vue?vue&type=template&id=5015f234&"
import script from "./LawyersList.vue?vue&type=script&lang=ts&"
export * from "./LawyersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports